import React, { useEffect, useState } from "react";
import "./message.css";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const MappingStreamDrawer = ({
  getMappingStream,
  setIsDrawerOpen,
  isDrawerOpen,
  drawerCaller,
  setBackDrop,
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "xs"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "sm"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  let drawerWidth = "600px";
  if (isXs || window.innerWidth < 1000) {
    drawerWidth = "250px";
  } else if (isSm) {
    drawerWidth = "300px";
  } else if (isMd) {
    drawerWidth = "400px";
  } else if (isLg) {
    drawerWidth = "600px";
  } else if (isXl) {
    drawerWidth = "600px";
  }
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [information, setInformation] = useState({});
  const handleDrawerClose = (event) => {
    // if (event.target.id === "back-button") {
      setIsDrawerOpen(false);
    // }
  };
  const createNewMappingStream = () => {
    const name = information?.mapping_stream_name?.trim();
    const url = information?.mapping_stream_url?.trim();
     const description = information?.mapping_stream_desc?.trim();
    if (name.length == 0 || url.length == 0 ) {
      setError("Please fill all the mandatory fields");
      setTimeout(() => {
        setError(null);
      }, 4000);
      return;
    }
    const body = {
      mapping_stream_id: information?.mapping_stream_id,
      mapping_stream_name: name,
      mapping_stream_url: `https://${url}`,
      mapping_stream_desc: description,
    };
    setBackDrop(true);
    instance
      .post("api/v1/Master/MappingStream/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getMappingStream();
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        if (type === "Add") {
          setInformation({
            mapping_stream_name: "",
            mapping_stream_url: "",
            mapping_stream_desc: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false);
      });
  };
  const OnchangeHandler = (event) => {
    const { id, value, type } = event?.target;
    if (type == "checkbox") {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: event?.target?.checked == true ? 1 : 0,
        };
      });
    } else {
      setInformation((prev) => {
        return {
          ...prev,
          [id]: value,
        };
      });
    }
  };
  useEffect(() => {
    setInformation({
      mapping_stream_id: filledInfo?.mapping_stream_id ?? 0,
      mapping_stream_desc: filledInfo?.mapping_stream_desc ?? "",
      mapping_stream_name: filledInfo?.mapping_stream_name ?? "",
      mapping_stream_url:
        filledInfo?.mapping_stream_url?.split("://").at(-1) ?? "",
    });
  }, [drawerCaller]);
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      PaperProps={{
        sx: {
          width: drawerWidth,
        },
      }}
    >
      <div style={{ padding: "20px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backmsg"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon onClick={handleDrawerClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colormsg mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add" : "Edit"} Mapping Stream{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colormsg mb-1"
              style={{ fontWeight: "600" }}
            >
              Mapping Stream Information{" "}
            </Typography>
          </Grid>
          {/* alert */}
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>

          <Grid item xs={12}>
            <InputLabel htmlFor="mapping_stream_name">
              {" "}
               Name<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="mapping_stream_name"
              size="small"
              value={information?.mapping_stream_name}
              onChange={OnchangeHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="mapping_stream_url">
              {" "}
               URL<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <TextField
              id="mapping_stream_url"
              size="small"
              variant="outlined"
              fullWidth
              value={information?.mapping_stream_url}
              onChange={OnchangeHandler}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" style={{ marginRight: "0" }}>
                    <span style={{ background: "lightgray", padding: "8px" }}>
                      https://
                    </span>
                  </InputAdornment>
                ),
              }}
              sx={{ "& .MuiInputBase-root": { paddingLeft: "0" } }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="mapping_stream_desc">
              Description
            </InputLabel>
            <TextField
              id="mapping_stream_desc"
              size="small"
              multiline
              rows={10}
              value={information?.mapping_stream_desc}
              onChange={OnchangeHandler}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={createNewMappingStream}
            >
              {type == "Add" ? "Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default MappingStreamDrawer;
